import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, List } from '@common-fe/common-fe';

interface Props {
  isAllClaimsSelected?: boolean;
  onSelectAllClaimsFromPage?: () => void;
}

const AssociateWithClaimsListHeader: React.FC<Props> = ({ isAllClaimsSelected, onSelectAllClaimsFromPage }) => {
  const { t } = useTranslation();

  return (
    <List.Header testId="associate-with-claims_header">
      {onSelectAllClaimsFromPage ? (
        <List.Header.Item flex={0.5}>
          <Checkbox
            testId="associate-with-claims-list_select-all-claims"
            checked={isAllClaimsSelected}
            onChange={onSelectAllClaimsFromPage}
          />
        </List.Header.Item>
      ) : null}
      <List.Header.Item flex={2} textAlign="center">
        {t('Provider')}
      </List.Header.Item>
      <List.Header.Item flex={1.5}>
        {t('Service description')}
      </List.Header.Item>
      <List.Header.Item flex={1} textAlign="center">
        {t('Amount')}
      </List.Header.Item>
      <List.Header.Item flex={0.7}>
        {t('Date')}
      </List.Header.Item>
    </List.Header>
  );
};

export default AssociateWithClaimsListHeader;
